import { useSelector } from 'react-redux'

import {
  selectIsAccountCreationFlowPending,
  selectIsUserHasAccount,
  selectIsUserSignedUp,
  selectUserStatus,
} from 'root-redux/selects/user'

import { useAvailableUpsellPages } from 'hooks/useAvailableUpsellPages'
import { usePostPaymentFlowConfig } from 'hooks/usePostPaymentFlowConfig'
import { usePostPaymentOrder } from 'hooks/usePostPaymentOrder'
import { useUserAccountType } from 'hooks/useUserAccountType'

import { PageId } from 'page-constants'

export const useUserStatus = (): string => {
  const userStatus = useSelector(selectUserStatus)
  const isAccountCreationFlowPending = useSelector(
    selectIsAccountCreationFlowPending,
  )
  const userHasAccount = useSelector(selectIsUserHasAccount)
  const isUserSignedUp = useSelector(selectIsUserSignedUp)
  const availableUpsellPages = useAvailableUpsellPages()
  const { downloadPageId } = usePostPaymentFlowConfig()

  const isLearnWorldsUser = useUserAccountType()
  const { isAccountBeforeUpsellOrder } = usePostPaymentOrder()

  const isAccountCreationAvailable =
    userStatus?.hasSubscription && !availableUpsellPages.length

  if (
    isAccountBeforeUpsellOrder &&
    userStatus?.hasSubscription &&
    ((!isLearnWorldsUser && !userHasAccount) || isAccountCreationFlowPending)
  ) {
    return PageId.ACCOUNT
  }

  if (userStatus?.hasSubscription && availableUpsellPages.length) {
    return availableUpsellPages[0]
  }

  if (
    isAccountCreationAvailable &&
    ((!isLearnWorldsUser && !userHasAccount) ||
      (isLearnWorldsUser && !isUserSignedUp))
  ) {
    return isLearnWorldsUser ? PageId.SIGNUP : PageId.ACCOUNT
  }

  if ((userHasAccount || isUserSignedUp) && !availableUpsellPages.length) {
    return downloadPageId
  }

  return ''
}
